import * as React from "react";
import { EntryCard } from "../components/entry-card";
import { CategoryEntries } from "../components/category-entries";
import { Link } from "gatsby";
export var CustomCategoryEntries = function CustomCategoryEntries(props) {
  return /*#__PURE__*/React.createElement(CategoryEntries, props, function (item) {
    var noImage = props.noImage;
    var title = item.tableOfContents.items[0].title;
    var widgetStart = title.indexOf('<');
    var titleText = title.slice(0, widgetStart);
    var titleWidget = title.slice(widgetStart);
    return /*#__PURE__*/React.createElement(EntryCard, {
      heading: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
        className: "no-decorators",
        to: item.fields.slug
      }, titleText), /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: titleWidget
        }
      })),
      excerpt: item.frontmatter.description || item.excerpt,
      imagePath: !noImage && item.fields.featuredImage,
      slug: item.fields.slug
    });
  });
};